import { formatCurrency } from '../../utils';
import { getCurrentLang } from '../../i18n/i18n';

/**
 * Renders a signed discount/surcharge for the price box: a positive value is a
 * discount (shown with a leading "-"), a negative value is a surcharge ("+").
 * Zero is shown without a sign.
 */
export function formatSignedDiscount(value: number): string {
    let sign = '';
    if (value > 0) {
        sign = '-';
    } else if (value < 0) {
        sign = '+';
    }
    return `${sign}${formatCurrency(Math.abs(value), getCurrentLang())}`;
}
